import React from "react";
import "./FaqMenuCard.css";
import { makeStyles } from "@material-ui/core/styles";
import YouTubeIcon from "@material-ui/icons/YouTube";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
  Paper,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  root1: {
    width: "100%",
    maxWidth: 360,
    // backgroundColor: theme.palette.background.paper,
  },
  root2: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  section1: {
    margin: theme.spacing(3, 2),
  },
  section2: {
    margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },
  button: {
    margin: theme.spacing(1),
  },
}));

export default function FaqMenuTypeUrl(props) {
  const classes = useStyles();

  let faqUrlData = props.faqUrlData;
  // console.log("faqUrlData: ", faqUrlData);

  return (
    // <Paper>
    <div className={classes.root}>
      <div className={classes.section1}>
        <Grid container alignItems="center">
          <Grid item xs>
            {/* <Paper> */}
            <List
              subheader={<ListSubheader>Please be guided by</ListSubheader>}
              className={classes.root}
            >
              {faqUrlData.map((data, i) => (
                // <List className={classes.root1}>
                <ListItem key={i}>
                  <ListItemIcon>
                    {data.urlType == "youtube" && <YouTubeIcon />}
                    {data.urlType == "pdf" && <PictureAsPdfIcon />}
                  </ListItemIcon>
                  {/* <ListItemText primary="url" /> */}
                  <ListItemSecondaryAction>
                    <Button variant="outlined" color="primary" href={data.url} target="_blank">
                      Link
                    </Button>
                  </ListItemSecondaryAction>
                </ListItem>
                // </List>
              ))}
            </List>
            {/* </Paper> */}
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
